import React from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import MarqueeQuote from "../components/MarqueeQuote";
import Phases from "../components/Phases";
import Manifesto from "../components/Manifesto";
import AuthorBio from "../components/AuthorBio";
import Testimonials from "../components/Testimonials";
import Pricing from "../components/Pricing";
import FAQSection from "../components/FAQSection";
import FinalCta from "../components/FinalCta";
import Footer from "../components/Footer";
import StickyBar from "../components/StickyBar";

export default function Landing() {
    return (
        <div
            data-testid="landing-page"
            className="relative min-h-screen overflow-hidden"
        >
            <Nav />
            <main className="relative z-10">
                <Hero />
                <MarqueeQuote />
                <Phases />
                <Manifesto />
                <AuthorBio />
                <Testimonials />
                <Pricing />
                <FAQSection />
                <FinalCta />
                <Footer />
            </main>
            <StickyBar />
        </div>
    );
}
